import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ProsperLogo } from "./ProsperLogo";

const NAV = [
  { to: "/investors", label: "Investors", testId: "nav-investors" },
  { to: "/media", label: "Media", testId: "nav-media" },
];

export const SharedHeader = ({ testId = "site-header" }) => {
  const { pathname } = useLocation();
  return (
    <header
      data-testid={testId}
      className="mx-auto max-w-7xl px-6 lg:px-10 pt-6 sm:pt-8 flex items-center justify-between"
    >
      <Link to="/" data-testid="header-logo-link" className="flex items-center">
        <ProsperLogo size="sm" testId="header-logo" />
      </Link>
      <nav className="flex items-center gap-6 sm:gap-8">
        {NAV.map((n) => {
          const active = pathname === n.to;
          return (
            <Link
              key={n.to}
              to={n.to}
              data-testid={n.testId}
              className={`text-sm font-medium transition-colors ${
                active ? "text-slate-900" : "text-slate-500 hover:text-slate-900"
              }`}
            >
              {n.label}
              {active && <span className="block h-[2px] w-full mt-0.5 bg-gradient-to-r from-[#22B6B0] to-[#7A5BFF] rounded-full" />}
            </Link>
          );
        })}
      </nav>
    </header>
  );
};

export default SharedHeader;
